import { AppEffects } from './app/app.effects';
import { AppReducers } from './app/app.reducers';
import { AppState } from './app/app.state';
import { AuthEffects } from './auth/auth.effects';
import { authReducers } from './auth/auth.reducers';
import { AuthState } from './auth/auth.state';
import { CustomerEffects } from './customer/customer.effects';
import { customerReducers } from './customer/customer.reducers';
import { ErrorEffects } from './error/error.effects';
import { ErrorReducers } from './error/error.reducers';
import { ErrorState } from './error/error.state';
import { OffersEffects } from './offers/offers.effects';
import { offerReducers } from './offers/offers.reducers';
import { OfferState } from './offers/offers.state';
import { OnboardingEffects } from './onboarding/onboarding.effects';
import { onboardingReducers } from './onboarding/onboarding.reducers';
import { PaymentsEffects } from './payments/payments.effects';
import { paymentsReducers } from './payments/payments.reducers';
import { PaymentsState } from './payments/payments.state';
export interface RootState {
  error: ErrorState;
  app: AppState;
  auth: AuthState;
  offer: OfferState;
  payments: PaymentsState;
}

export const appReducers = {
  error: ErrorReducers,
  app: AppReducers,
  auth: authReducers,
  onboarding: onboardingReducers,
  customer: customerReducers,
  offers: offerReducers,
  payments: paymentsReducers,
};

export const appEffects = [
  ErrorEffects,
  AppEffects,
  AuthEffects,
  OnboardingEffects,
  CustomerEffects,
  OffersEffects,
  PaymentsEffects,
];
